export class Praktischpage {
  foto1!: string;
  foto2!: string;
}
